import { useMemo } from "react";
import { useCrmFilterFields } from "@/react/hooks/useCrmFilters";
import { useIsActivityScoreEnabledOrUpgradable } from "@circle-react/hooks/useIsActivityScoreEnabled";
import { MemberFilters } from "@circle-react-shared/MemberFilters";
import { AllFiltersList } from "@circle-react-shared/MemberFilters/DynamicFilters/AllFiltersList";
import type { RenderFilter } from "@circle-react-shared/MemberFilters/types";
import { useCrmTrueLocationFieldAndSearchEnabled } from "../../shared/MemberFilters/useCrmLocationEnabled";
import { memberDirectoryFilters } from "../memberDirectoryFilters";

const platformMemberFilters: RenderFilter[] = memberDirectoryFilters;

export const MembersFilters = () => {
  const isActivityScoreEnabledOrUpgradable =
    useIsActivityScoreEnabledOrUpgradable();

  const isCrmTrueLocationFieldAndSearchEnabled =
    useCrmTrueLocationFieldAndSearchEnabled();

  const crmFilters = useCrmFilterFields();

  const defaultFilterItems = useMemo(() => {
    const items = ["name", "spaces", "tags", "events"];
    if (isActivityScoreEnabledOrUpgradable) {
      items.push("activity_score");
    }

    if (isCrmTrueLocationFieldAndSearchEnabled) {
      items.unshift("near_me");
      items.push("geo_location");
    }
    return items;
  }, [
    isActivityScoreEnabledOrUpgradable,
    isCrmTrueLocationFieldAndSearchEnabled,
  ]);

  return (
    // Mobile version of filters are not ready, so hide for time being
    <div className="shadow-xs hidden md:flex">
      <MemberFilters
        platformFilters={[...platformMemberFilters, ...crmFilters]}
        defaultFilterNames={defaultFilterItems}
        persistentFilterNames={
          isCrmTrueLocationFieldAndSearchEnabled ? ["near_me"] : []
        }
      >
        <AllFiltersList />
      </MemberFilters>
    </div>
  );
};
